<template>
    <div class="backbtn" @click="fanhui()">
        <img src="../../assets/images/backicon.png" alt="">
    </div>
</template>

<script>
export default {
    components: {
    },
    name: 'floatback',
    data() {
        return {

        }
    },
    computed: {
    },
    created() {
        document.title = "CCDS第四届中国皮肤外科大会";
    },
    beforeDestroy() {

    },
    methods: {
        fanhui() {
            this.$router.push({ name: 'CCDS' })
        }
    }
}
</script>

<style lang="scss" scoped>
.backbtn {
    width: 13%;
    position: fixed;
    right: 0;
    top: 50%;
    opacity: .8;
    transform: translateY(-50%);
}

.backbtn {
    img {
        width: 100%;
    }
}
</style>